import { CanActivateFn } from '@angular/router';
import { LocalStorageKeys } from '../models/auth.models';

const ACCESS_CONTROL_LIST = [
	{ key: 'tecalis', testsAccess: true, modelsAccess: true },
	{ key: 'tecalis_tests', testsAccess: true },
	{ key: 'marketing_demo', testsAccess: true },
	{ key: 'rentik', testsAccess: true },
	{ key: 'waiis', testsAccess: true },
];

export const securityCodeGuard: CanActivateFn = (route, state) => {
	// if (window.location.hostname === 'localhost') {
	// 	localStorage.setItem(LocalStorageKeys.security_code, 'tecalis');
	// 	return true;
	// }

	// Obtener código de seguridad
	let code = route.queryParams['security'];
	if (!code) code = prompt('Introduce el código de seguridad');

	// Obtener la ruta
	const routePath = state.url;

	// Verificar si tiene acceso según el código y la ruta
	const accessControl = ACCESS_CONTROL_LIST.find((entry) => entry.key === code);
	if (accessControl) {
		if (routePath.includes('/models') && accessControl.modelsAccess) {
			// MODELS
			localStorage.setItem(LocalStorageKeys.security_code, code);
			return true;
		} else if (routePath.includes('/tests') && accessControl.testsAccess) {
			// TESTS
			localStorage.setItem(LocalStorageKeys.security_code, code);
			return true;
		}
	}

	// Redirigir a la página de error si no tiene acceso
	window.location.href = '/error/not-access';
	return false;
};
